import { Routes, Route } from "react-router-dom";
import ProtectedRoutes from "./ProtectedRoutes";
import DashboardPage from "../pages/dashboardPage/DashboardPage";

const DashboardNavigator = () => {
  return (
    <Routes>
      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoutes>
            <DashboardPage />
          </ProtectedRoutes>
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoutes>
            <DashboardPage />
          </ProtectedRoutes>
        }
      />
    </Routes>
  );
};

export default DashboardNavigator;
